import { c as _c } from "react/compiler-runtime";
import { classNames, DropdownItem, DropdownItemAvatar, DropdownItemContent, DropdownItemDescription, DropdownItemTitle } from "@opensea/ui-kit";
import { useButton } from "../../../../../components/Button/useButton";
function ProfileDropdownItem(t0) {
  const $ = _c(10);
  let className;
  let restProps;
  if ($[0] !== t0) {
    ({
      className,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = restProps;
  } else {
    className = $[1];
    restProps = $[2];
  }
  const {
    renderLink: Link,
    onClick
  } = useButton(restProps);
  let t1;
  if ($[3] !== Link) {
    t1 = linkProps => <Link {...linkProps} />;
    $[3] = Link;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== className || $[6] !== onClick || $[7] !== restProps || $[8] !== t1) {
    t2 = <DropdownItem className={className} renderLink={t1} {...restProps} onClick={onClick} />;
    $[5] = className;
    $[6] = onClick;
    $[7] = restProps;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function ProfileDropdownAvatar(t0) {
  const $ = _c(8);
  let className;
  let restProps;
  if ($[0] !== t0) {
    ({
      className,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = restProps;
  } else {
    className = $[1];
    restProps = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames(className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== restProps || $[6] !== t1) {
    t2 = <DropdownItemAvatar className={t1} size={24} {...restProps} />;
    $[5] = restProps;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { ProfileDropdownItem, ProfileDropdownAvatar as ProfileDropdownItemAvatar, DropdownItemContent as ProfileDropdownItemContent, DropdownItemTitle as ProfileDropdownItemTitle, DropdownItemDescription as ProfileDropdownItemDescription };